<template>
  <div class="main">
    <my_menu2 page_name="长期工项目面试流程"
      back_type="close"
      back_icon="md-close"
    ></my_menu2>
    <div style="height:40px"></div>

    <div class="content">
      <div class="tabs_div">
        <Tabs v-model="tabs_append" @on-click="tabs_click">
          <TabPane
            v-for="(item, i) in tabs_item_list"
            :key="i"
            :label="item.name"
            :name="item.value"
          >
          </TabPane>
        </Tabs>
        <div class="project_name_div">
          <span>当前项目：{{ project_name }}</span>
        </div>
      </div>

      <div class="inner_content">
        <daimianshi
          ref="daimianshi"
          :project_id="current_project_id"
          v-show="tabs_append == '待面试'"
        >
        </daimianshi>
        <mianshizhong
          ref="mianshizhong"
          :project_id="current_project_id"
          v-show="tabs_append == '面试中'"
        >
        </mianshizhong>
        <dairuzhi
          ref="dairuzhi"
          :project_id="current_project_id"
          v-show="tabs_append == '待入职'"
        ></dairuzhi>
        <ruzhi
          ref="ruzhi"
          :project_id="current_project_id"
          v-show="tabs_append == '入职'"
        ></ruzhi>
        <lizhi
          ref="lizhi"
          :project_id="current_project_id"
          v-show="tabs_append == '离职'"
        ></lizhi>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import daimianshi from "./component/daimianshi.vue";
import mianshizhong from "./component/mianshizhong.vue";
import dairuzhi from "./component/dairuzhi.vue";
import ruzhi from "./component/ruzhi.vue";
import lizhi from "./component/lizhi.vue";
import merge from "webpack-merge";
import { ref } from "vue";
import { nextTick } from "process";
import watermark from "@/utils/shuiyin.js";
import my_menu2 from '@/component/menu/menu2.vue'


var dms = null;
export default {
  components: {
    daimianshi,
    mianshizhong,
    dairuzhi,
    ruzhi,
    lizhi,
    my_menu2
  },

  data() {
    return {
      textTitle: "项目列表",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      tabs_item_list: [
        { name: "待面试表", value: "待面试" },
        { name: "面试中表", value: "面试中" },
        { name: "待入职表", value: "待入职" },
        { name: "入职表", value: "入职" },
        { name: "离职表", value: "离职" },
      ],
      project_name: "",
      current_project_id: "",
      tabs_append: "",
    };
  },

  mounted() {
    var that = this;

    var query = this.$route.query;

    // 项目id
    var project_id = query.project_id;
    if (project_id) {
      this.current_project_id = project_id;
    }
    //
    var tabs_append = query.tabs_append;
    if (tabs_append) {
      this.tabs_append = tabs_append;
    }
    // adhh
    var project_name = query.project_name;
    if (project_name) {
      this.project_name = project_name;
    }

    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };

    // 获取数据
    this.get_table_data();
  },

  methods: {
    get_table_data() {
      console.log(this.tabs_append);
      console.log(this.current_project_id);
      console.log(this.$refs);
      if (this.tabs_append == "待面试") {
        this.$refs.daimianshi.open();
      }

      if (this.tabs_append == "面试中") {
        this.$refs.mianshizhong.open();
      }

      if (this.tabs_append == "待入职") {
        this.$refs.dairuzhi.open();
      }
      if (this.tabs_append == "入职") {
        this.$refs.ruzhi.open();
      }
      if (this.tabs_append == "离职") {
        this.$refs.lizhi.open();
      }
    },

    search() {
      this.page = 1;
      this.get_my_project_list();
    },

    page_change(e) {
      this.page = e;
      this.get_my_project_list();
    },

    click_roster(row, status) {
      console.log(row);
      var project_id = row.project_id;
      open_new_page(
        "/roster_manage/detail?project_id=" +
          project_id +
          "&job_status=" +
          status +
          "&project_name=" +
          row.project_name
      );
    },

    update_tabs() {},

    click_count(item, status) {
      var route = this.$route;
      var path =
        route.path +
        "?tabs_append=" +
        status +
        "&project_id=" +
        item.project_id +
        "&project_name=" +
        item.project_name;
      // // 打开新窗口
      open_new_page(path, "_blank");
    },

    //点击项目名称
    click_project_name(item, status) {
      this.current_project_id = item.project_id;
      this.$router.push({
        query: merge(this.$route.query, {
          tabs_append: status,
          project_id: this.current_project_id,
        }),
      });
      this.tabs_append = status;

      this.update_tabs();
    },

    tabs_click(e) {
      console.log(e);
      console.log(this.$refs);
      console.log("tab_click");
      this.tabs_append = e;

      this.$router.push({
        query: merge(this.$route.query, {
          tabs_append: e,
          project_id: this.current_project_id,
        }),
      });

      this.get_table_data();
      // console.log(e)
      // if (e == 0) {
      //     this.tabs_item_list = [{ name: '项目列表' }]
      //     this.tabs_index = 0
      //     // 置0
      //     this.daimianshi_show = false
      //     this.mianshizhong_show = false
      //     this.$router.push({
      //         query: merge({}, {})
      //     })
      //     this.get_my_project_list()
      // }
    },

    //获取项目列表-数量
    get_my_project_count(project_id_list, status) {
      var that = this;
      var obj = {
        project_id_list: project_id_list,
        status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_interview_count",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var data = res.data.data_dict;
            this.update_interview_count(status, data);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新数量
    update_interview_count(status, data) {
      for (let i = 0; i < this.table_data.length; i++) {
        if (data[this.table_data[i]["project_id"]]) {
          this.table_data[i][status] = data[this.table_data[i]["project_id"]];
        } else {
          this.table_data[i][status] = 0;
        }
      }
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.inner_content {
  overflow: auto;
  height: calc(100vh - 90px);
  /* margin: 0 10px 10px 10px; */
}

.loading_gif {
  width: 12px;
  height: 12px;
}

.hmc_span {
  display: flex;
  justify-content: space-between;
}

.search_box {
  margin: 0 10px;
}

.project_type_tag {
  background-color: #ccc;
  padding: 2px 5px;
  color: #ffffff;
  border-radius: 3px;
  font-size: 10px;
}

.project_name_div {
  padding: 2px 15px;
  font-size: 13px;
  font-weight: 300;
  color: #fff;
  background-color: #0466dd;
  border-radius: 100px;
  position: absolute;
  right: 10px;
}

.tabs_div {
  padding: 0px 5px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table_num_title {
  flex-shrink: 0;
  margin-right: 3px;
}

.table_num_div {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.table_click {
  cursor: pointer;
  color: #515a6e;
  width: 100px;
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.table_click:hover {
  color: #0c6ce2;
}

.hmc_span_txt {
  cursor: pointer;
  color: #515a6e;
  margin-right: 10px;
  width: 90px;
  text-align: left;
  display: flex;
  align-items: center;
}

.hmc_span_txt:hover {
  color: #0c6ce2;
}

.table_a {
  cursor: pointer;
  color: #515a6e;
  margin-right: 10px;
}

.table_a:hover {
  color: #0c6ce2;
}

.table_a_box {
  display: flex;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
  background-color: #fff;
  padding: 10px 10px 0 10px;
  border-radius: 5px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.main {
  background: #f5f7f9;
  min-height: calc(100vh - 60px);
  min-width: 1200px;
}

</style>
